module.exports = __webpack_public_path__ + "img/carousel-vet-10.3e1d9610.jpg";